const aboutMenu = () => {
    initMenuEffect()
    $(window).on('reisze', function(){
        initMenuEffect();
    })
}

const initMenuEffect = () => {
    let prevIndex = 0;
    $(".eye-menu-vertical").on("mouseover", "li", function () {
        if ($(this).hasClass("text-red")) return

        const curIndex = $(this).index();
        const $parent = $(this).parents(".eye-menu-vertical");
        //kiểm tra đang chạy animation không
        if ($parent.attr("data-changing") == "1") return;

        const $indicator = $parent.find(".indicator");
        const menuItemHeight = $(this).height();
        const menuItemWidth = $(this).width();

        $(".eye-menu-vertical li").removeClass("text-red")
        $(this).addClass("text-red")

        let newTop = $(this).position().top;

        if (curIndex > prevIndex) {
            //đang di chuyển xuống
            newTop -= 16;
        }
        prevIndex = curIndex

        $indicator.css({
            transform: `translateY(${newTop}px)`,
            height: menuItemHeight + 17
        });



    })
    $(".eye-menu-vertical").on("mouseleave", "ul", function () {
        $(".eye-menu-vertical li.active").mouseover();
    })
    $(".eye-menu-vertical li.active").mouseover();
    let img = $(".eye-menu-vertical").parents(".row").find(".page-title img");
    let imgHeight = $(img).height();
    let marginImg = 0.1725  * imgHeight;
    // console.log(marginImg)
    $(".eye-menu-vertical").css({
        marginTop: (60 + marginImg)
    })
}
module.exports = aboutMenu;
